<script setup>
definePage({ meta: { layout: "blank" } });

// Router
const route = useRoute();
const router = useRouter();
const backToLogin = async (e) => {
  try {
    useCookie("userData").value = null;
    useCookie("accessToken").value = null;
    useCookie("refreshToken").value = null;

    setTimeout(() => router.push({ path: "/" }), 1000);
  } catch (err) {
    console.error(err);
  }
};
</script>
<template>
  <div class="misc-wrapper">
    <div>
      <!-- 👉 Title and subtitle -->
      <div class="text-center mb-4">
        <h2 class="text-h2 font-weight-medium mb-5">
          You're not Authorized! 🚀
        </h2>
        <VBtn @click="backToLogin()">Please login</VBtn>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
